import type { ReactNode } from 'react';
import { CloseButton } from '../LiliCloseButton';
import { Heading } from '../../tokens';
import { ReactComponent as BackArrowIcon } from '../../../assets/shared/ic-shared-back-arrow.svg';
import { LiliLinkButton } from '../LiliLink/LiliLinkButton';
import { LiliLinkType } from '../LiliLink';

export interface NavigationHeaderProps {
  onBack?: () => void;
  onClose?: () => void;
  disableMarginBottom?: boolean;
  hideBorder?: boolean;
  title: string;
  backButtonTitle?: string;
  backIcon?: ReactNode;
  className?: string;
}

export const NavigationHeader = ({
  onBack,
  onClose,
  disableMarginBottom,
  hideBorder,
  title,
  backButtonTitle = 'Back',
  backIcon,
  className,
}: NavigationHeaderProps) => {
  return (
    <div
      className={`h-[56px] min-h-[56px] w-full flex items-center px-[34px] ${disableMarginBottom ? '' : 'mb-[64px]'} ${hideBorder ? '' : 'border-b border-outline-primary-bw-03'} bg-surface-primary-bw-00 ${className ?? ''}`}>
      <div className='flex items-center w-[88px] shrink-0'>
        {onBack ? (
          <LiliLinkButton
            onClick={onBack}
            className='w-fit'
            id='navigation-header-back'
            title={backButtonTitle}
            leftIcon={backIcon ?? <BackArrowIcon />}
            type={LiliLinkType.SECONDARY_QUITE}
          />
        ) : (
          <span className='w-[88px]' />
        )}
      </div>
      <Heading.H9 className='flex-1 text-center'>{title}</Heading.H9>
      <div className='flex items-center justify-end w-[88px] shrink-0'>
        {onClose ? (
          <CloseButton id='navigation-header-close' onClick={onClose} />
        ) : (
          <span className='w-[88px]' />
        )}
      </div>
    </div>
  );
};
